import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { EditAthletesForm } from 'local/components'

const AthletesUpdateComponent = ({
  onSubmit,
  getAthleteInfoById,
  athleteId,
}) => {
  const [initialValues, setInitialValues] = useState('')
  useEffect(() => {
    getAthleteInfoById(athleteId).then((response) => {
      setInitialValues(response)
    })
  }, [])

  return initialValues ? (
    <EditAthletesForm
      header="Update Athlete"
      onSubmit={onSubmit}
      initialValues={initialValues}
    />
  ) : (
    <div></div>
  )
}

AthletesUpdateComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getAthleteInfoById: PropTypes.any,
  athleteId: PropTypes.any,
}

export default AthletesUpdateComponent
